module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/gold-hover-50.003f2356.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/gold-hover-50.png
// module id = 3446
// module chunks = 11